/**
 * API 辅助工具，用于处理 Cloudflare API 请求
 */

// 缓存上次请求的时间戳
let lastRequestTimestamp = 0;

/**
 * 调用 Cloudflare API 的包装函数
 * @param taskType 任务类型
 * @param payload 请求负载
 * @returns API 响应
 */
export const callCloudflareAPI = async (taskType: string, payload: any): Promise<any> => {
  console.log(`调用 Cloudflare API: ${taskType}`, payload);
  
  // 记录当前请求时间
  lastRequestTimestamp = Date.now();
  
  try {
    const response = await fetch('https://ai-assistant-api.openaitool.cn/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        taskType,
        studentId: '8',
        ...payload
      })
    });
    
    if (!response.ok) {
      throw new Error(`API 请求失败: ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log(`收到 Cloudflare API 响应: ${taskType}`, data);
    return data;
  } catch (error) {
    console.error(`Cloudflare API 错误: ${taskType}`, error);
    throw error;
  }
};

/**
 * 检查是否正在等待 API 响应
 * @param timeoutMs 超时时间（毫秒）
 * @returns 是否正在等待响应
 */
export const isWaitingForResponse = (timeoutMs = 10000): boolean => {
  if (lastRequestTimestamp === 0) return false;
  
  const elapsed = Date.now() - lastRequestTimestamp;
  return elapsed < timeoutMs;
};

/**
 * 重置请求状态
 */
export const resetRequestState = (): void => {
  lastRequestTimestamp = 0;
};
